import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import {useIntl} from 'react-intl';


import hasRole from '../../../contexts/Auth/hooks/hasRole';

import styles from '../MainNavigation.scss';


function NavItem({className, isExact, labelI18n, path, requiredRole}) {

    const {formatMessage} = useIntl();
    const label = formatMessage({id: labelI18n});

    const hasRequiredRole = hasRole(requiredRole);
    if (!hasRequiredRole) {

        return null;
    }

    return (
        <li
            className={className}
        >
            <NavLink
                className={({isActive}) => isActive ? styles.active : null}
                aria-current={'page'}
                aria-label={label}
                to={path}
            >
                {label}
            </NavLink>
        </li>
    );
}


NavItem.propTypes = {
    className: PropTypes.string,
    isExact: PropTypes.bool.isRequired,
    labelI18n: PropTypes.string,
    path: PropTypes.string.isRequired,
    requiredRole: PropTypes.string
};

NavItem.defaultProps = {
    isExact: false
};


export default NavItem;
